"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.constants = void 0;
exports.constants = {
    EMAIL_STATUS_HEADER_KEY: 'emailstatus',
    EMAIL_STATUS_HEADER_VALUE_BLACK_LISTED: 'black-listed',
    EMAIL_STATUS_HEADER_VALUE_NOT_WHITE_LISTED: 'not-white-listed',
};
